var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurkish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_21478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.985 12.7323L17.4511 14.7527L19.8256 13.9828L18.3571 16.0014L19.8231 18.0218L17.4495 17.2491L15.981 19.2677L15.9825 16.7715L13.6088 15.9986L15.9834 15.2287L15.985 12.7323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9839 21.0501C9.1948 21.0501 6.93374 18.7891 6.93374 16C6.93374 13.2108 9.19474 10.9498 11.9839 10.9498C12.8535 10.9498 13.6718 11.1696 14.3862 11.5567C13.2655 10.4608 11.7329 9.78433 10.0416 9.78433C6.60886 9.78433 3.82605 12.5671 3.82605 15.9999C3.82605 19.4326 6.60886 22.2155 10.0416 22.2155C11.7329 22.2155 13.2655 21.539 14.3862 20.4431C13.6718 20.8302 12.8535 21.0501 11.9839 21.0501Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_21478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkish);
export default __webpack_public_path__ + "static/media/Turkish.a579cd194f86feb120ea58e25cca5b12.svg";
export { ForwardRef as ReactComponent };